import React, { Component } from 'react'

import Button from '@material-ui/core/Button';
// import speech from '@google-cloud/speech'

const urlAudio = 'https://firebasestorage.googleapis.com/v0/b/okdsprojects.appspot.com/o/audio.mp3?alt=media&token=08731cb9-33ed-4508-b328-31a63aa9de1f'

import View from 'react-flexbox'
export default class Home extends Component {

    trascreve() {
        // Imports the Google Cloud client library
        // const speech = require('@google-cloud/speech');
        // const fs = require('fs');

        // // Creates a client
        // const client = new speech.SpeechClient();

        // // The name of the audio file to transcribe
        // const fileName = './audio.mp3';

        // // Reads a local audio file and converts it to base64
        // const file = fs.readFileSync(fileName);
        // const audioBytes = file.toString('base64');

        // // The audio file's encoding, sample rate in hertz, and BCP-47 language code
        // const audio = {
        //     content: audioBytes,
        // };
        // const config = {
        //     encoding: 'LINEAR16',
        //     sampleRateHertz: 16000,
        //     languageCode: 'pt-BR',
        // };
        // const request = {
        //     audio: audio,
        //     config: config,
        // };

        // // Detects speech in the audio file
        // const [response] = await client.recognize(request);
        // const transcription = response.results
        //     .map(result => result.alternatives[0].transcript)
        //     .join('\n');
        // console.log(`Transcription: ${transcription}`);
    }
    render() {
        return (
            // <div>
            <View style={{ alignItems: 'flex-start'}}>
                Bem vindo ao OK Projects
                {/* <Button onClick={() => this.trascreve()}>
                    Vai
                </Button> */}
            </View>
            // </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/private/Home/Home.js